import { html } from "lit";
var icon_inProgress_default = () => html`
  <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <defs>
      <path
        d="M3 4.6c4-4.7 10.5-6 15.8-3.1.1 0 .4.4 0 1-.2.6-.9.3-1 .3a11.2 11.2 0 1 0 5.9 7c-.1-.3 0-.8.5-1 .4-.2 1 .1 1 .4A12.9 12.9 0 1 1 3 4.6Z"
        id="a" />
    </defs>
    <g fill-rule="evenodd">
      <use fill-rule="nonzero" xlink:href="#a" transform="translate(2.3 4)" />
      <path
        d="M24.3 4.3a2 2 0 0 1 2.8 0L29 6c.8.8.8 2 0 2.8l-11 11a2 2 0 0 1-1 .5l-2.1.3a2 2 0 0 1-2.3-2.3l.3-2c0-.5.3-.9.6-1.2Zm-1.2 3.4-8.6 8.6-.1.3-.3 2a.4.4 0 0 0 .4.5l2.1-.3.3-.1 8.6-8.6-2.4-2.4ZM26 5.4a.4.4 0 0 0-.6 0l-1.2 1.2L26.6 9l1.2-1.2c.1-.2.2-.4 0-.5Z"
        fill-rule="nonzero" />
    </g>
  </svg>
`;
export {
  icon_inProgress_default as default
};
//# sourceMappingURL=icon-inProgress.js.map
